import React from 'react';
import { withTranslation } from "react-i18next";
import { validLocale } from '../../utils/validate';
import { parseQueryParameters } from '../../utils/queryStringHandler';
import { setMarketDataLayer } from '../../utils/GTM';
import globalConfig from '../../config/global/config.json';
import './UnsupportedBrowser.scss'
import i18n from '../../i18n';
import { withRouter } from '../../utils/withRouter';

class UnsupportedBrowser extends React.Component {  
  
  render() {
    parseQueryParameters();
    let { localeName } = this.props.match.params;
    const locale = (localeName === "" || localeName === undefined)
      ? globalConfig.SET_DEFAULT_MARKET
      : localeName;
    if(validLocale(locale))
    {
      i18n.changeLanguage(locale.replace('-','_'));
      if (sessionStorage.getItem('locale') !== locale) {
        setMarketDataLayer(locale);
        sessionStorage.setItem('locale', locale);
      }
    }
    const { t } = this.props;
    return (
          <div className="unsupported-browser-pop-up p-4 ">
            <p>{t("unsupportedBrowser#description")}</p>
            <ul>
              {t("unsupportedBrowser#browserList", {returnObjects: true}).map((browser, i) => 
                <li key={i}>
                  <a href={browser.url} target="_blank" rel="noreferrer">{browser.label}</a>
                </li>
              )}
            </ul>
          </div>
    );
  }
}
export default withTranslation()(withRouter(UnsupportedBrowser));